import CreateCollectionPopup from "desktop/components/create_collection_popup";
import CoachMark from "desktop/components/coach_mark";
import Lights from "shared/components/lights";

const popupTemplate = require('templates/popups/add_to_collection_popup.jst.jade')

export default class AddToCollectionPopup {
  constructor(options) {
    this.el = $(options.element);
    this.body = $('body');
    this.html = null;
    this.ui = {
      root: '.popup',
      list: '.popup__list',
      searchBox: 'input.popup__search-collection',
      close: '.popup__close',
      checkbox: '.popup__list input[type="checkbox"]',
      flash: '.js-add-to-collection-flash'
    };
    this.videoId = this.el.data("video-id");
    this.userId = this.el.data("user-id");
    this.timer = null;
    this.coachMark = new CoachMark({ element: this.el.parent('[data-component="CoachMark"]') });
    this.lights = Lights;
  }

  init() {
    this.el.on('click', this.onClick.bind(this));
  }

  navbarSelector() {
    return $('header#navbar');
  }

  onClick(e) {
    this.clearTimer();
    e.preventDefault();
    e.stopPropagation();
    document.getElementsByTagName("body")[0].style.overflow = 'hidden';
    this.lights.off.bind(this)();
    this.getCollections();
    this.pausePlayer();
    this.coachMark.close();
    this.hideNavbar(this.navbarSelector());
  }

  clearTimer() {
    if(this.timer !== null) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  render(collections) {
    var lang = $("meta[name=language]").attr("content");
    var content = $(popupTemplate({ video_id: this.videoId, user_id: this.userId, collections: collections, locale: window.Locale[lang] }));
    this.html = content;
  }

  getCollections() {
    $.ajax({
      method: 'GET',
      url: '/collections.json?video_id=' + this.videoId,
      dataType: 'json'
    })
    .done(this.onGetCollectionsSuccess.bind(this))
    .fail(this.onGetCollectionsFailed.bind(this));
  }

  bindOnClose() {
    $(this.ui.close).on('click', this.onClose.bind(this));
  }

  pausePlayer() {
    if(window.player) {
      window.player.tech().pause();
    }
  }

  onClose() {
    $(this.ui.root).remove();
    this.lights.on();
    this.showNavbar(this.navbarSelector());
  }

  close() {
    this.onClose();
  }

  onGetCollectionsSuccess(data) {
    this.render(data);
    this.body.append(this.html);
    this.bindOnClose();
    this.bindOnCheckboxChange();
    this.bindOnSearchKeyup();
    $(this.ui.searchBox).focus();
    new CreateCollectionPopup({element: $('[data-component="CreateCollectionPopup"]')[0]}).init();
  }

  onGetCollectionsFailed(){
    this.render("[]");
    this.body.append(this.html);
    this.bindOnClose();
  }

  bindOnCheckboxChange() {
    $(this.ui.checkbox).on('change', this.onCheckboxChange.bind(this));
  }

  onCheckboxChange(e) {
    if(e.target.checked){
      this.addVideoToCollection(e.target.id);
    } else {
      this.removeVideoFromCollection(e.target.id);
    }
  }

  addVideoToCollection(channel_id) {
    $.ajax({
      method: 'POST',
      url: '/collections.json?video_id=' + this.videoId,
      dataType: 'json',
      data: "channel_id=" + channel_id
    })
    .done(this.onAddVideoToCollectionSuccess.bind(this))
    .fail(this.onAddVideoToCollectionFailed.bind(this));
  }

  removeVideoFromCollection(channel_id) {
    $.ajax({
      method: 'DELETE',
      url: '/collections/' + channel_id + '.json?video_id=' + this.videoId,
      dataType: 'json'
    })
    .done(this.onRemoveVideoFromCollectionSuccess.bind(this))
    .fail(this.onRemoveVideoFromCollectionFailed.bind(this));
  }

  onAddVideoToCollectionSuccess() {
    this.onClose();
    this.showFlash("notification--success", "Berhasil memasukkan vidio ke collection");
  }

  onAddVideoToCollectionFailed(response) {
    this.onClose();
    this.showFlash("notification--danger", response.responseText);
  }

  onRemoveVideoFromCollectionSuccess() {
    this.onClose();
    this.showFlash("notification--success", "Berhasil menghapus vidio dari collection");
  }

  onRemoveVideoFromCollectionFailed() {
    this.onClose();
    this.showFlash("notification--danger", "Gagal menghapus vidio dari collection");
  }

  showFlash(cssClass, content) {
    $(this.ui.flash).addClass(cssClass).html(content);
    this.timer = setTimeout(function() {
      $(this.ui.flash).removeClass(cssClass).html('');
    }.bind(this), 3000);
  }

  bindOnSearchKeyup() {
    $(this.ui.searchBox).on('keyup', this.onSearchKeyup.bind(this));
  }

  onSearchKeyup(e){
    var searchText = $(e.target).val().toLowerCase();
    $(this.ui.list).each(function(){
      var title = $(this).data('title').toLowerCase();
      if(title.match(searchText)){
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  }

  hideNavbar($element) {
    $element.addClass('hide-navbar');
  }

  showNavbar($element) {
    $element.removeClass('hide-navbar');
  }

}
